import React from 'react';
import { CommonHeader } from '../../components/commons';
import './SupportPage.scss';

type AppProps = {
    history: any;
}

const Support = ({ history }: AppProps) => {
    return (
        <div className="support-page-wrapper">
            <div className="card">
                <div className="card-body">
                    <CommonHeader title="Support" />
                    <div className="mb-4 mt-4"> Feel free to connect with our highly talented team to solve all your queries. Here are a few ways to be in touch with us:</div>

                    <div className="row">
                        <div className="col-md-4">
                            <div className="support-info-block tollFree">
                                <a href="tel:18008919244">
                                    <i className="las la-phone" style={{ color: '#5bbae9' }}></i>
                                    <h3>Toll Free</h3>
                                    <p>1800 891 9244</p>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="support-info-block emailSupport">
                                <a href="mailto:info@stco.co.in">
                                    <i className="las la-envelope" style={{ color: '#f54136' }}></i>
                                    <h3>Email</h3>
                                    <p>
                                        info@stco.co.in
                                    </p>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="support-info-block whatsapp">
                                <a href="https://web.whatsapp.com/send?phone=917000209293" target="_blank">
                                    <i className="lab la-whatsapp" style={{ color: '#00e676' }}></i>
                                    <h3>Whatsapp</h3>
                                    <p>+91-7000209293</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Support;